<template>
    <DataTable :value="tableData" class="p-datatable-sm" :paginator="true" :rows="rowsPerPage"
        :totalRecords="totalRecords" :first="(currentPage - 1) * rowsPerPage" :rowsPerPageOptions="[10, 20, 50]"
        :lazy="true" :loading="isLoading" @page="onPage">

        <Column header="Date">
            <template #body="{ data }">
                {{ new Date(data.created_at).toLocaleDateString() }}
            </template>
        </Column>

        <Column header="Student">
            <template #body="{ data }">
                <div class="flex flex-column">
                    <span>{{ data.studentId?.username }}</span>
                    <small class="text-gray-500">{{ data.studentId?.email }}</small>
                </div>
            </template>
        </Column>

        <Column header="Class Info">
            <template #body="{ data }">
                <div class="flex flex-column">
                    <span>{{ cleanupLables(data.classId?.subject) }}</span>
                    <small class="text-gray-500">{{ cleanupLables(data.classId?.grade) }}</small>
                </div>
            </template>
        </Column>

        <Column header="Class Fee">
            <template #body="{ data }">
                {{ formatCurrency(data.classFee, data.currency) }}
            </template>
        </Column>

        <Column header="Commission (Rate)">
            <template #body="{ data }">
                {{ formatCurrency(data.platformCommission, data.currency) }} ({{ data.commissionRate }}%)
            </template>
        </Column>

        <Column field="totalPayhereFee" header="PayHere Fee">
            <template #body="{ data }">
                {{ formatCurrency(data.payhereFee ?? 0) }}
            </template>
        </Column>

        <Column header="Tutor Payout">
            <template #body="{ data }">
                <strong>{{ formatCurrency(data.adjustedTutorPayout, data.currency) }}</strong>
            </template>
        </Column>

        <!-- <Column field="status" header="Status">
            <template #body="{ data }">
                <Button v-if="data.status === 'failed'" label="Failed" severity="danger"
                    class="p-button-rounded p-button-outlined" disabled size="small" />
                <Button v-else-if="data.status === 'paid'" label="Paid" severity="success"
                    class="p-button-rounded p-button-outlined" disabled size="small" />
                <Button v-else-if="data.status === 'hold'" label="On Hold" severity="warn"
                    class="p-button-rounded p-button-outlined" disabled size="small" />
                <Button v-else label="Pending" severity="secondary" class="p-button-rounded p-button-outlined" disabled
                    size="small" />
            </template>
        </Column> -->
        <Column header="Tutor Confirmation">
            <template #body="{ data }">
                <Tag
                    :value="data.classConfirmedByTutor ? 'Confirmed' : 'Pending'"
                    :severity="data.classConfirmedByTutor ? 'success' : 'warn'"
                    rounded
                    style="padding: 3px 10px; font-size: 0.7rem;"
                />
            </template>
        </Column>

        <Column header="Student Confirmation">
            <template #body="{ data }">
                <Tag
                    :value="data.classConfirmedByStudent ? 'Confirmed' : 'Pending'"
                    :severity="data.classConfirmedByStudent ? 'success' : 'warn'"
                    rounded
                    style="padding: 3px 10px; font-size: 0.7rem;"
                />
            </template>
        </Column>

        <Column field="status" header="Status">
            <template #body="{ data }">
                <template v-if="data.status === 'paid'">
                    <Tag
                        v-if="data.classConfirmedByTutor && data.classConfirmedByStudent"
                        value="Valid Payout"
                        severity="success"
                        rounded
                        style="padding: 3px 10px; font-size: 0.7rem;"
                    />
                    <Tag
                        v-else
                        value="Invalid Payout"
                        severity="danger"
                        rounded
                        style="padding: 3px 10px; font-size: 0.7rem;"
                    />
                </template>
                <Tag
                    v-else
                    :value="data.status === 'hold' ? 'On Hold' : data.status.charAt(0).toUpperCase() + data.status.slice(1)"
                    :severity="data.status === 'failed' ? 'danger' : data.status === 'hold' ? 'warn' : 'secondary'"
                    rounded
                    style="padding: 3px 10px; font-size: 0.7rem;"
                />
            </template>
        </Column>

        <template #paginatorstart>
            <div class="text-sm Caption">
                Showing {{ tableData.length }} of {{ totalRecords }} records
            </div>
        </template>

        <template #empty>
            <div class="flex align-items-center justify-content-center" style="min-height: calc(100vh - 600px)">
                <div class="text-center">
                    <i class="pi pi-history" style="font-size: 2rem; color: var(--surface-400)"></i>
                    <p class="mt-2 text-color-secondary">No payment history found for this tutor.</p>
                </div>
            </div>
        </template>
    </DataTable>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
// import Button from 'primevue/button';
import Tag from 'primevue/tag';
import { cleanupLables } from "@/utils/cleanups";

defineProps({
    tableData: Array,
    isLoading: Boolean,
    rowsPerPage: Number,
    totalRecords: Number,
    currentPage: Number
});

const emit = defineEmits(["page-change"]);

const onPage = (event) => {
    const page = Math.floor(event.first / event.rows) + 1;
    const limit = event.rows;
    emit("page-change", { page, limit });
};

const formatCurrency = (value, currencyCode = 'LKR') => {
    return new Intl.NumberFormat('en-LK', { style: 'currency', currency: currencyCode }).format(value);
};
</script>